module.exports = __webpack_public_path__ + "img/tijiao2x.bd1b8bff.png";